export { Toast } from './Toast';
export * from './styles';

export type { ToastType } from './Toast';
